import { Task, TaskDataStore, taskSelectors } from '@skinsoft/entity';
import { Featured } from '@skinsoft/ui';
import { Observable, of } from 'rxjs';
import { catchError, merge } from 'rxjs/operators';

import { resolveAuthor } from '../../resolve-author';
import { resolveDescription } from './resolve-description';

export function toFeatured$(task: Task): Observable<Featured> {
    const featured: Featured = {
        author: taskSelectors.author(task),
        date: taskSelectors.endDate(task),
        description: taskSelectors.associatedTasks(task)[0],
        headerDate: taskSelectors.startDate(task),
        highlight: TaskDataStore.highlightStates.includes(taskSelectors.state(task)),
        id: task.id,
        state: taskSelectors.state(task),
        stateLabel: `task.state.${taskSelectors.state(task)}`,
        title: taskSelectors.incrementalTitle(task),
    };

    const featured$ = of(featured);

    return featured$.pipe(
        merge(of({ ...featured, author: null } as Featured), featured$.pipe(
            resolveAuthor,
            resolveDescription,
        ) as Observable<Featured>),
        catchError(error => of({ ...featured, author: error })),
    );
}
